export const DATE_FILTERS = [
  { key: "lastWeek", label: "Last 7 Days", daysAgo: 7 },
  { key: "lastMonth", label: "Last 30 Days", daysAgo: 30 },
  { key: "custom", label: "Custom Date" },
];

export const DATE_FILTERS_M = [
  { key: "lastMonth", label: "Last 1 Month", daysAgo: 30 },
  { key: "lastThreeMonth", label: "Last 3 Months", daysAgo: 90 },
  { key: "custom", label: "Custom Date" },
];
